module.exports = __webpack_public_path__ + "static/media/attention.13176e01.svg";